window.addEventListener('load', function() {
    let swiperOptions = {
        slidesPerView: 1,
        loop: true,
        autoHeight: true,
        // autoplay: {
        //     delay: 5000,
        //     disableOnInteraction: true,
        //   },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
    };
    
    const bannerSlider = new Swiper('.bannerSlider', swiperOptions);
});